
import { Component, Vue } from 'vue-property-decorator'
import { videoSelectPage } from '@/api'
import { QuestionPageParam, IAllVideoType } from '@/types/type'
import Header from '@/components/componentWap/Header.vue'
@Component({
    name: 'VideoList',
    components: {
        Header
    }
})
export default class extends Vue {
    private loading = false
    private keyWord = this.$route.query.keyWord as string || ''
    private questionParams = new QuestionPageParam()
    private total: number = 0
    private isShowMore = false
    // 详情
    private goDetail(id: string) {
        this.$jump(`/Video/VideoDetail?videoId=${id}`)
    }
    private editData: IAllVideoType[] = []
    private async getBaseSearch() {
        this.loading = true
        this.questionParams.title = this.keyWord
        let res = await videoSelectPage(this.questionParams).catch(() => this.loading = false)
        this.editData = this.editData.concat(res.data.list)
        this.total = res.data.total
        if (this.questionParams.pageNum && this.questionParams.pageSize) {
            this.isShowMore = this.total / (this.questionParams.pageNum * this.questionParams.pageSize) > 1
        }
        this.loading = false
    }
    // 加载更多
    private addMore() {
        if (!this.isShowMore) return
        if (this.questionParams.pageNum) {
            this.questionParams.pageNum++
            this.getBaseSearch()
        }
    }
    created() {
        this.getBaseSearch()
    }
    private handleScroll () {
        const scrollTop = document.documentElement.scrollTop
        const scrollHeight = document.documentElement.scrollHeight
        const clientHeight = document.documentElement.clientHeight
        if (scrollTop + clientHeight >= scrollHeight) {
            this.addMore()
        }
    }
    mounted () {
        window.addEventListener('scroll', this.handleScroll)
    } 
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
